import { withRouter } from 'react-router-dom';
import GeneratingRoomCodePage from './GeneratingRoomCodePage';

export default withRouter(GeneratingRoomCodePage);
